import React from "/vendor/react";

import { ExportIcon} from "/lib/component/icon";
import MenuItem from "./MenuItem";

const Export = props => <MenuItem {...props} />;

Export.displayName = "ToolbarMenuItems.Reset";

Export.defaultProps = {
  title: "Export",
  icon: <ExportIcon />,
};

export default Export;
